import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Auto_ProductRef from '../StoreRoomTransfer/Auto_ProductRef';
import Auto_Ref from '../StoreRoomTransfer/Auto_Ref';
import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import GetTax from '../Common/GetTax';
import PN from "persian-number";
import Auto_User from '../User/Auto_User.js';



const InsertTransferIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const RefRef = useRef()
    const UserRef = useRef()
    const ProductRef = useRef()
    const GetTaxRef = useRef()
    const StoreRef = useRef()
    const SupplierStoreRef = useRef()
    const [ItemList, setItemList] = useState([]);
    const [HeaderId, setHeaderId] = useState(localStorage.getItem("TransferHeaderId"));
    const [Tax, setTax] = useState(0);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [Code, setCode] = useState("");

    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [Type, setType] = useState(localStorage.getItem("TransferType"));
    const [TypeComment, setTypeComment] = useState(localStorage.getItem("TransferType") == 1 ? "حواله فروش" :
        localStorage.getItem("TransferType") == 2 ? "حواله انتقال بین انبارها" :
            localStorage.getItem("TransferType") == 3 ? "حواله برگشت از خرید" :
                localStorage.getItem("TransferType") == 4 ? "حواله کالای امانی" :
                    localStorage.getItem("TransferType") == 5 ? " حواله برگشت کالای امانی" :
                        localStorage.getItem("TransferType") == 7 ? " حواله کسری انبار" : "");
    const [IsCustomer, setIsCustomer] = useState(localStorage.getItem("TransferType") == 1 || localStorage.getItem("TransferType") == 4 || localStorage.getItem("TransferType") == 5 ? 1 : 0);
    const [IsCoWorker, setIsCoWorker] = useState(localStorage.getItem("TransferType") == 1 || localStorage.getItem("TransferType") == 4 || localStorage.getItem("TransferType") == 5 ? 1 : 0);
    const [IsSupplier, setIsSupplier] = useState(localStorage.getItem("TransferType") == 3 || localStorage.getItem("TransferType") == 4 || localStorage.getItem("TransferType") == 5 ? 1 : 0);

    const [RemainCount, setRemainCount] = useState(0);
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [DiscountType, setDiscountType] = useState(0);
    const [SumItemPrice, setSumItemPrice] = useState(0);
    const [HeaderDiscount, setHeaderDiscount] = useState(0);
    const [HeaderTax, setHeaderTax] = useState(0);
    const [FreightPrice, setFreightPrice] = useState(0);
    const [InsertDate, setInsertDate] = useState(moment(new Date())); // moment((new Date).format("jYYYY/jMM/jDD"))
    const [ReadOnlyInsertDate, setReadOnlyInsertDate] = useState("");
    const [SupplierId, setSupplierId] = useState(General.GuidEmpty().toString());
    const [Supplier, setSupplier] = useState("");


    //#endregion



    // const Type_Change = (e) => {
    //     setType(e.target.value)
    //     setRemainCount(0);
    //     setItemList([]);
    //     if (Type == 0)
    //         setFreightPrice(0);
    // }

    const Supplier_Change = (e) => {
        setSupplierId(General.GuidEmpty())
        setSupplier("")

        if (e.split("|").length > 1) {

            setSupplier(e.split("|")[1] );
            setSupplierId(e.split("|")[0]);
            return;
        }
        setSupplier(e);
        UserRef.current.GetForAuto_Total(e, IsCustomer, IsCoWorker, IsSupplier)
    }

    const Supplier_Select = (e) => {
        setSupplier(e.split("|")[1]);
        setSupplierId(e.split("|")[0]);
        return;
    }

    const change_DiscountType = (e, checked) => {
        setDiscountType(checked == true ? 1 : 0)
    }


    const InsertDate_Change = e => {
        setItemList([]);
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setInsertDate(moment(m, 'jYYYY/jMM/jDD'));


    }

    // const Change_FreightPrice = (e) => {
    //     setFreightPrice(PN.sliceNumber(e.replaceAll(',', '')));
    //     var sumItemPrice = SumItemPrice != '0' ? SumItemPrice.toString().replaceAll(',', '') : 0
    //     var headerDiscount = HeaderDiscount != '0' ? HeaderDiscount.toString().replaceAll(',', '') : 0
    //     var headerTax = HeaderTax != '0' ? HeaderTax.toString().replaceAll(',', '') : 0
    //     var freightPrice = e > '0' ? e.replaceAll(',', '') : 0
    //     var headerPrice = sumItemPrice * 1 + headerDiscount * 1 + headerTax * 1 + freightPrice * 1
    //     setHeaderPrice(headerPrice);
    // }


    //#region Methods


    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomTransfer/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': HeaderId
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setInsertDate(moment(result.insertDate, 'jYYYY/jMM/jDD'))
                    setReadOnlyInsertDate(result.insertDate)
                    setType(result.type);
                    setHeaderPrice(result.price);
                    setStoreRoomId(result.storeRoomId);
                    setSupplierId(result.supplierId);
                    setSupplier(result.supplier);
                    setCode(result.code);

                })
        )
    }

    const Reset = () => {
        setItemList([]);
        setHeaderId(General.GuidEmpty());
        setCode("");
        setStoreRoomId(-1);
        // setType(-1);
        setRemainCount(0);
        setHeaderPrice(0);
        setDiscountType(0);
        setSumItemPrice(0);
        setHeaderDiscount(0);
        setHeaderTax(0);
        // setFreightPrice(0);
        setInsertDate(moment(new Date()));
        setReadOnlyInsertDate("");
        setSupplierId(General.GuidEmpty().toString());
        setSupplier("");
    }

    const Save = () => {

        if (StoreRoomId == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب انبار اجباری می باشد")), 'topCenter')
            return;
        }
        if (InsertDate == "" || InsertDate == null) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ رسید اجباری می باشد")), 'topCenter')
            return;
        }
        if (Type == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" نوع رسید اجباری می باشد")), 'topCenter')
            return;
        }
        if (SupplierId == General.GuidEmpty() && Type > 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب تامین کننده اجباری می باشد")), 'topCenter')
            return;
        }
        if (ItemList.length == 0 || (ItemList.length == 1 && ItemList[0].status != "EDIT")) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" لیست رسید محصول اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": HeaderId,
                "SupplierId": SupplierId,
                "Price": HeaderPrice,
                "InsertDate": moment(InsertDate.format()).format('jYYYY/jMM/jDD'),
                "Type": Type,
                "StoreRoomId": StoreRoomId,
                "FiscalYearId": FiscalYearId,
                "FreightPrice": FreightPrice != "0" ? FreightPrice.replaceAll(",", "") : 0,
                "DiscountType": DiscountType ? 1 : 0,
                "Children": [...ItemList].filter(item => item.ProductId != General.GuidEmpty() && item.status != 'EDIT'),
            },
            url: General.ApiRoute() + "/StoreRoomTransfer/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        if (HeaderId == General.GuidEmpty())
                            Reset();
                        else {
                            localStorage.removeItem("TransferHeaderId");
                            localStorage.removeItem("TransferType");
                            navigate("/Transfer")
                        }
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const onEditItem = (row) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].status = "EDIT";
            temp[index].Tax = PN.sliceNumber(temp[index].Tax);
            temp[index].Price = PN.sliceNumber(temp[index].Price);
            temp[index].TotalPrice = PN.sliceNumber(temp[index].TotalPrice);
            temp[index].DiscountPrice = PN.sliceNumber(temp[index].DiscountPrice);
        }
        setItemList(temp);
    }

    const NewItem = () => {
        if (Type != -1 && StoreRoomId != -1) {
            setItemList([
                ...ItemList,
                {
                    row: ItemList.length + 1,
                    ProductId: General.GuidEmpty(),
                    ProductTitle: '',
                    Editable: true,
                    Id: General.GuidEmpty(),
                    status: "EDIT",
                    RefId: General.GuidEmpty(),
                    RefTitle: "",
                    Count: 0,
                    TotalPrice: 0,
                    Price: 0,
                    Tax: 0,
                    DiscountPrice: 0,
                    DiscountPercent: 0,
                    DiscountType: DiscountType,
                }

            ]);
            setTimeout(() => {
                RefRef.current.Bind(Type, '', moment(InsertDate.format()).format("jYYYY/jMM/jDD"))

            }, 200)
        }
        else
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انبار و نوع رسید را انتخاب کنید")), 'topCenter')

    }
    const Change_Item = (row, dataType, value) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);

        if (index != -1) {

            var price = temp[index].Price > '0' ? temp[index].Price.replaceAll(",", "") : 0
            var discountPrice = temp[index].DiscountPrice > '0' ? temp[index].DiscountPrice.replaceAll(",", "") : 0
            var discountPercent = temp[index].DiscountPercent;
            var tax = temp[index].Tax > '0' ? temp[index].Tax.replaceAll(",", "") : 0
            var totalPrice = 0;




            if (dataType == "Price") {
                price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                discountPrice = DiscountType == 1 ? Math.trunc(price * temp[index].DiscountPercent * 1 / 100) : discountPrice;
                discountPercent = DiscountType == 1 ? temp[index].DiscountPercent : Number.parseFloat(discountPrice * 100 / price).toFixed(2);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);

                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count * 1;
                temp[index].DiscountPrice = PN.sliceNumber(discountPrice);
                temp[index].DiscountPercent = discountPercent;
                temp[index].Price = PN.sliceNumber(price);
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
                temp[index].Tax = PN.sliceNumber(tax);
            }
            else if (dataType == "Count") {
                temp[index].Count = value;
                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * value * 1;
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
            }
            else if (dataType == "DiscountPrice") {
                discountPrice = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                discountPercent = Number.parseFloat(discountPrice * 1 * 100 / price * 1).toFixed(2);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);
                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count * 1;
                temp[index].DiscountPrice = PN.sliceNumber(discountPrice);
                temp[index].DiscountPercent = discountPercent;
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
                temp[index].Tax = PN.sliceNumber(tax);
            }

            else if (dataType == "DiscountPercent") {
                discountPercent = value;
                discountPrice = Math.trunc(value * price / 100);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);
                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count;
                temp[index].DiscountPrice = PN.sliceNumber(discountPrice);
                temp[index].DiscountPercent = discountPercent;
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
                temp[index].Tax = PN.sliceNumber(tax);
            }

            else if (dataType == "Ref" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                temp[index].RefId = General.GuidEmpty();
                temp[index].ProductTitle = "";
                temp[index].RemainCount = 0;
                setRemainCount(0);
                if (value.indexOf("|") > 1) {
                    temp[index].RefTitle = value.split("|")[1];
                    temp[index].RefId = value.split("|")[0];

                    return;
                }
                temp[index].RefTitle = value;
                RefRef.current.Bind(Type, value, moment(InsertDate.format()).format("jYYYY/jMM/jDD"))
            }
            else if (dataType == "ProductRef" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                if (value.indexOf("|") > 1) {
                    temp[index].ProductTitle = value.split("|")[1];
                    temp[index].RemainCount = value.split("|")[2];
                    temp[index].ProductId = value.split("|")[0];
                    return;
                }
                temp[index].ProductTitle = value;
                temp[index].RemainCount = 0;
                ProductRef.current.Bind(Type, -1, -1, value, temp[index].RefId)
            }
            // else if (dataType == "DiscountPercent") {

            //     temp[index].ProductTitle = value;
            //     temp[index].RemainCount = 0;
            //     ProductRef.current.Bind(Type, -1, -1, value, temp[index].RefId)
            // }

        }
        setItemList(temp);
    }

    const Select_Item = (row, dataType, value) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            if (dataType == "Ref") {
                temp[index].RefId = value.split("|")[0];
                temp[index].RefTitle = value.split("|")[1];
                ProductRef.current.Bind(Type, -1, -1, "", value.split("|")[0])
            }
            else if (dataType == "ProductRef") {
                temp[index].ProductId = value.split("|")[0];
                temp[index].ProductTitle = value.split("|")[1];
                temp[index].RemainCount = value.split("|")[2];
            }
            setItemList(temp);
        }
    }

    const SaveItem = (row) => {


        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (temp[index].Price == "0" || temp[index].Price == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("قیمت محصول اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].Count == "0" || temp[index].Count == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("تعداد محصول اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].ProductId == General.GuidEmpty()) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب محصول اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].RefId == General.GuidEmpty() && Type != 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب مبنا اجباری می باشد")), 'topCenter')
                return;
            }

            temp[index].status = "";
            temp[index].Tax = temp[index].Tax != "0" && temp[index].Tax != 0 ? temp[index].Tax.replaceAll(',', '') * 1 : 0;
            temp[index].Price = temp[index].Price != "0" && temp[index].Price != 0 ? temp[index].Price.replaceAll(',', '') * 1 : 0;
            temp[index].TotalPrice = temp[index].TotalPrice != "0" && temp[index].TotalPrice != 0 ? temp[index].TotalPrice.replaceAll(',', '') * 1 : 0;
            temp[index].DiscountPrice = temp[index].DiscountPrice != "0" && temp[index].DiscountPrice != 0 ? temp[index].DiscountPrice.replaceAll(',', '') * 1 : 0;
            var freightPrice = FreightPrice > '0' ? FreightPrice.replaceAll(',', '') : 0
            setHeaderTax(temp.map(o => o.Tax).reduce((a, b) => a + b));
            setHeaderDiscount(temp.map(o => o.DiscountPrice).reduce((a, b) => a + b));
            setSumItemPrice(temp.map(o => o.Price).reduce((a, b) => a + b));
            setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1 + freightPrice * 1);
            if (temp.filter(item => item.ProductId == General.GuidEmpty()).length == 0)
                temp.push({
                    row: temp.length + 1,
                    ProductId: General.GuidEmpty(),
                    ProductTitle: '',
                    Editable: true,
                    Id: General.GuidEmpty(),
                    status: "EDIT",
                    RefId: General.GuidEmpty(),
                    RefTitle: "",
                    Count: 0,
                    TotalPrice: 0,
                    Price: 0,
                    Tax: 0,
                    DiscountPrice: 0,
                    DiscountPercent: 0,
                    DiscountType: DiscountType,
                })


            setItemList(temp);
        }


    }

    const DeleteItem = (row) => {

        var temp = [...ItemList.filter(item => item.row !== row)];
        setItemList(temp);
        var freightPrice = FreightPrice > '0' ? FreightPrice.replaceAll(',', '') : 0
        if (temp.length > 0) {
            setHeaderTax(temp.map(o => o.Tax).reduce((a, b) => a + b));
            setHeaderDiscount(temp.map(o => o.DiscountPrice).reduce((a, b) => a + b));
            setSumItemPrice(temp.map(o => o.Price).reduce((a, b) => a + b));
            setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1 + freightPrice * 1);

        }
        else {
            setHeaderTax(0);
            setHeaderDiscount(0);
            setSumItemPrice(0);
            setHeaderPrice(freightPrice);

        }


    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", localStorage.getItem("TransferType") == 1 ? 44 : 13);
        myHeaders.append("Operation", HeaderId != General.GuidEmpty() ? 3 : 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("TransferHeaderId") != undefined && localStorage.getItem("TransferHeaderId") != General.GuidEmpty())
                            GetById();
                        GetTaxRef.current.Get();
                        // ParentGroupRef.current.BindGroupByParentId(-1, 0);
                        StoreRef.current.Bind(-1);
                        if (localStorage.getItem("TransferType") != 0 &&
                            localStorage.getItem("TransferType") != 2 &&
                            localStorage.getItem("TransferType") != 6)
                            UserRef.current.GetForAuto_Total("", -1, -1, -1)
                        else if (localStorage.getItem("TransferType") == 2)
                            SupplierStoreRef.current.Bind(-1);


                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    useEffect(() => {
        CheckPermission();
        document.title = TypeComment;
    }, [])
    //#endregion







    return (

        <Layout title={"ثبت " + TypeComment} >
            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Save}>  ثبت</rsuite.Button>
                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => (localStorage.removeItem("TransferHeaderId"), navigate("/Transfer"))}>  بازگشت</rsuite.Button>
                                <GetTax ref={GetTaxRef} onSubmit={(value) => setTax(value)} />
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                            <label>کد</label>
                            <rsuite.Input disabled value={Code} onChange={(e) => setCode(e)} />
                        </rsuite.Col>
                        <rsuite.Col className={localStorage.getItem("TransferType") != 2 && localStorage.getItem("TransferType") != 0 && localStorage.getItem("TransferType") != 6 ? '' : "hide"} xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                            <label>مشتری </label>
                            <Auto_User className="FocusItem " disabled={HeaderId == General.GuidEmpty() ? false : true} value={Supplier} onChange={Supplier_Change} onSelect={Supplier_Select} ref={UserRef} />
                        </rsuite.Col>
                        <rsuite.Col className={localStorage.getItem("TransferType") == 2 ? '' : "hide"} xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>انبار تامین کننده</label>
                            <Drp_StoreRoom disabled={HeaderId == General.GuidEmpty() ? false : true} className='rs-input' value={SupplierId} onChange={(e, title) => (setSupplierId(e), setSupplier(title))} ref={SupplierStoreRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> تاریخ </label>
                            {HeaderId == General.GuidEmpty() ?
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={InsertDate} onChange={InsertDate_Change} />
                                :
                                <rsuite.Input disabled value={ReadOnlyInsertDate} />

                            }

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>انبار </label>
                            <Drp_StoreRoom disabled={HeaderId == General.GuidEmpty() ? false : true} className='rs-input' value={StoreRoomId} onChange={(e) => setStoreRoomId(e)} ref={StoreRef} />
                        </rsuite.Col>




                        {/* <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>نوع</label>
                            <select disabled={HeaderId == General.GuidEmpty() ? false : true} className="rs-input" onChange={Type_Change} value={Type}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">اول دوره</option>
                                <option value="1">فاکتور خرید </option>
                                <option value="2">جابه جای بین انبار </option>
                                <option value="3">برگشت از فروش </option>


                            </select>
                        </rsuite.Col> */}
                        {/* <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>هزینه باربری (ریال)</label>
                            <rsuite.Input disabled={Type == 0 ? true : false} value={FreightPrice} onChange={Change_FreightPrice} />
                            <rsuite.Text className='Font10 float-start' as='sub'>{FreightPrice != "0" ? <>{PN.convert(FreightPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col> */}
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Checkbox onChange={(e, checked) => change_DiscountType(e, checked)} checked={DiscountType} value={DiscountType} /> &nbsp;    تخفیف به درصد می باشد

                        </rsuite.Col>

                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1">
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Button appearance="primary" color="green" size='xs'
                                onClick={() => NewItem()}>
                                اضافه شدن مشخصات جدید
                            </rsuite.Button>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                            <rsuite.Table height={320} data={ItemList} rowHeight={70}>
                                <rsuite.Table.Column width={50} align="center"  >
                                    <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey="row">
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                <rsuite.Table.Column flexGrow={1} fullText resizable>
                                    <rsuite.Table.HeaderCell>مبنا</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >

                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (
                                                    <Auto_Ref className="rs-input" value={rowData.RefTitle} onChange={value => {
                                                        Change_Item?.(rowData.row, "Ref", value);
                                                    }}
                                                        onSelect={value => {
                                                            Select_Item?.(rowData.row, "Ref", value);
                                                        }}
                                                        ref={RefRef} />
                                                ) : (
                                                    <text>

                                                        {rowData.RefTitle}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>

                                <rsuite.Table.Column width={100} flexGrow={1} fullText resizable>
                                    <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >


                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (
                                                    // <rsuite.Badge color={RemainCount > 0 ? 'green' : "red"} content={Type > 0 ? " باقیمانده :"+ {RemainCount} + "عدد" : false}>
                                                    <Auto_ProductRef className="rs-input" value={rowData.ProductTitle} onChange={value => {
                                                        Change_Item?.(rowData.row, "ProductRef", value);
                                                    }
                                                    }
                                                        onSelect={value => {
                                                            Select_Item?.(rowData.row, "ProductRef", value);
                                                        }} ref={ProductRef} />
                                                    // </rsuite.Badge>
                                                ) : (
                                                    <text>

                                                        {rowData.ProductTitle}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>


                                <rsuite.Table.Column width={100} >
                                    <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >
                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (

                                                    <rsuite.Input value={rowData.Count} onChange={value => {
                                                        Change_Item?.(rowData.row, "Count", value);
                                                    }} />

                                                ) : (
                                                    <text>

                                                        {rowData.Count}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>


                                <rsuite.Table.Column flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input value={rowData.Price} onChange={value => {
                                                            Change_Item?.(rowData.row, "Price", value);
                                                        }}

                                                        />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.Price)}
                                                        {/* <br/>
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text> */}

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                {DiscountType != 0 ?

                                    <rsuite.Table.Column width={100} >
                                        <rsuite.Table.HeaderCell>تخفیف (%)</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.status == 'EDIT' ? (
                                                        <>

                                                            <rsuite.Input disabled={DiscountType == 0 ? true : false} value={rowData.DiscountPercent} onChange={value => {
                                                                Change_Item?.(rowData.row, "DiscountPercent", value);
                                                            }}

                                                            />
                                                        </>

                                                    ) : (
                                                        <text>
                                                            {rowData.DiscountPercent}

                                                        </text>
                                                    )}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    : <></>}
                                <rsuite.Table.Column flexGrow={1} >
                                    <rsuite.Table.HeaderCell>تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input disabled={DiscountType == 1 ? true : false} value={rowData.DiscountPrice} onChange={value => {
                                                            Change_Item?.(rowData.row, "DiscountPrice", value);
                                                        }}

                                                        />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.DiscountPrice != "0" ? <>{PN.convert(rowData.DiscountPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.DiscountPrice)}
                                                        {/* <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.DiscountPrice)} ریال</> : ""}</rsuite.Text> */}

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                {Tax != 0 ?
                                    <rsuite.Table.Column flexGrow={1} >
                                        <rsuite.Table.HeaderCell>مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.status == 'EDIT' ? (
                                                        <>

                                                            <rsuite.Input disabled value={rowData.Tax} />
                                                            <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Tax != "0" ? <>{PN.convert(rowData.Tax.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                        </>

                                                    ) : (
                                                        <text>
                                                            {PN.sliceNumber(rowData.Tax)}
                                                            {/* <br/>
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Tax != "0" ? <>{PN.convert(rowData.Tax)} ریال</> : ""}</rsuite.Text> */}

                                                        </text>
                                                    )}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    : <></>}

                                <rsuite.Table.Column flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>
                                                        <rsuite.Input value={rowData.TotalPrice} disabled />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.TotalPrice != "0" ? <>{PN.convert(rowData.TotalPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>
                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.TotalPrice)}
                                                        {/* <br/>
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.TotalPrice != "0" ? <>{PN.convert(rowData.TotalPrice)} ریال</> : ""}</rsuite.Text> */}

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>



                                <rsuite.Table.Column width={100} fixed='right'>
                                    <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.Editable ?
                                                    !rowData.ForParent ?
                                                        <>

                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                        :
                                                        <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />




                                                    :
                                                    <></>
                                                }
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                            </rsuite.Table>



                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1 Font17 '>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>تخفیف کل : </b> {PN.sliceNumber(HeaderDiscount)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderDiscount != "0" ? <>{PN.convert(HeaderDiscount.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={Tax == 0 ? "hide" : "mt-2"} >
                            <b>مالیات کل : </b> {PN.sliceNumber(HeaderTax)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderTax != "0" ? <>{PN.convert(HeaderTax.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                            <b>قیمت کل : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>


                    </rsuite.Row>

                </rsuite.Panel >
            </div >



        </Layout >


    )
}

export default InsertTransferIndex;